/** WMS 页面路径常量。跨页面跳转的路径统一从这里取，避免同一路径在多处各写一遍字面量 */
export const WMS_NO_UPDATE_WAREHOUSE_PATH = '/wms/no-update-warehouse';
export const WMS_DAILY_TASK_MONITORING_PATH = '/wms/delivery/daily-task-monitoring';
export const WMS_DELIVERY_MONITOR_PATH = '/wms/delivery/delivery-monitor';
export const WMS_DEPARTURE_REVIEW_PATH = '/wms/review';
